import React, { Fragment, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { Store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'
import estilos from '../../UsuarioInspectorEnCampo/Asociados/Tabs/TabsInspeccionarComponent.module.css'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import estilosTab from '../../UsuarioInspectorEnCampo/Asociados/Tabs/TabsInspeccionarComponent.module.css'
import VisualizarMovimientosComponent from './VisualizarMovimientosComponent';
function VisualizarTrazabilidad(props) {

    const dispatch = useDispatch()

    const [openTipoMovimiento, setOpenTipoMovimiento] = React.useState(false);

    const handleOpenTipoMovimiento = (l) => {
        setOpenTipoMovimiento(true)
    }

    const handleCloseTipoMovimiento = () => {
        setOpenTipoMovimiento(false)
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1500,
        height: 850,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    let objetoPruebas = {
        "id": "25-577",
        "metodoCoccion": "Horno de pozo",
        "fechaRegistro": "03 DE MAYO DE 2019",
        "cliente": "0051",
        "fabrica": "2 PEDRO CRUZ RUIZ",
        "estado": "OAXACA",
        "maestro": "PEDRO CRUZ RUIZ",
        "tapada": "30",
        "predio": 3899,
        "predioEnsamble": null,
        "maguey": "MAGUEY ESPADÍN",
        "magueyEnsamble": null,
        "pinas": 149,
        "agaveCoccion": 12960,
        "periodoCoccionI": "28/04/2019",
        "periodoCoccionF": "02/05/2019",
        "art": 42,
        "periodoMoliendaI": "13/05/2019",
        "periodoMoliendaF": "15/05/2019",
        "periodoFormulacionI": "15/05/2019",
        "periodoFormulacionF": "29/05/2019",
        "periodoDestilacionI": "21/05/2019",
        "periodoDestilacionF": "29/05/2019",
        "noDestilaciones": 2,
        "ltsProducidos": 1625,
        "grado": 42,
        "ltsExistentes": 0,
        "estatus": "Producido",
        "inspector": "UZIEL CRUZ BORJAS",
        "metodoMolienda": "Desgarradora",
        "metodoFermentacion": "Recipientes de madera",
        "metodoDestilacion": "Alambique de caldera de cobre con montera de cobre",
        "movimientos": {
            "PRODUCCION": [
                {
                    "principal": {
                        "produccion": "30",
                        "fechaAlta": "03-05-2019",
                        "inspector": "UZIEL CRUZ BORJAS",
                        "fechaRendimiento": "10-06-2019",
                        "inspectorRendimiento": "JOAQUIN BAUTISTA VIVEROS",
                        "litrosProducidos": 1625,
                        "gradoProducido": 42,
                        "motor": 1
                    }
                },
                {
                    "division": {
                        "produccion": "H1-811-A",
                        "fechaAlta": "08-03-2021",
                        "inspector": "RAFAEL VALDIVIA GARCES",
                        "fechaRendimiento": "22-03-2021",
                        "inspectorRendimiento": "RAFAEL VALDIVIA GARCES",
                        "litrosProducidos": 2250,
                        "gradoProducido": 45,
                        "motor": 0
                    }
                },
                {
                    "division": {
                        "produccion": "H1-811-B",
                        "fechaAlta": "08-03-2021",
                        "inspector": "RAFAEL VALDIVIA GARCES",
                        "fechaRendimiento": "22-03-2021",
                        "inspectorRendimiento": "RAFAEL VALDIVIA GARCES",
                        "litrosProducidos": 500,
                        "gradoProducido": 42,
                        "motor": 1
                    }
                }
            ],
            "FABRICA": [
                {
                    "ingreso": [
                        {
                            "produccion": "28",
                            "litros": 1380,
                            "grado": 42,
                            "fecha": "12-06-2019",
                            "inspector": "UZIEL CRUZ BORJAS",
                            "loteGranel": "VID-193"
                        },
                        {
                            "produccion": "29",
                            "litros": 1400,
                            "grado": 42,
                            "fecha": "12-06-2019",
                            "inspector": "UZIEL CRUZ BORJAS",
                            "loteGranel": "VID-193"
                        },
                        {
                            "produccion": "30",
                            "litros": 1625,
                            "grado": 42,
                            "fecha": "12-06-2019",
                            "inspector": "UZIEL CRUZ BORJAS",
                            "loteGranel": "VID-193"
                        },
                        {
                            "produccion": "31",
                            "litros": 1670,
                            "grado": 42,
                            "fecha": "12-06-2019",
                            "inspector": "AZARIEL JULIAN RIOS",
                            "loteGranel": "VID-193"
                        }
                    ]
                },
                {
                    "alta": [
                        {
                            "lote": "VID-193",
                            "clase": "JOVEN",
                            "categoria": "MEZCAL ARTESANAL",
                            "litros": 6075,
                            "grado": 42,
                            "fecha": "12-06-2019",
                            "inspector": "JOAQUIN BAUTISTA VIVEROS"
                        }
                    ]
                },
                {
                    "movimientos": [
                        {
                            "loteGranel": "VID-193",
                            "folio": "",
                            "litros": 6075,
                            "grado": 42,
                            "fecha": "12-06-2019",
                            "loteDos": "VID-193",
                            "observaciones": null,
                            "litrosExi": 0,
                            "gradoExi": 0,
                            "inspector": "JOAQUIN BAUTISTA VIVEROS",
                            "tipoMov": "4",
                            "movimientoLote": "",
                            "descripcion": "INGRESO DE LITROS PROVENIENTES DE OTROS LOTES"
                        },
                        {
                            "loteGranel": "VID-212",
                            "folio": "52001346LB",
                            "litros": 3,
                            "grado": 42,
                            "fecha": "24-03-2021",
                            "loteDos": null,
                            "observaciones": null,
                            "litrosExi": 0,
                            "gradoExi": 0,
                            "inspector": "RAFAEL VALDIVIA GARCES",
                            "tipoMov": "10",
                            "movimientoLote": "",
                            "descripcion": "SALIDA POR MUESTREO"
                        },
                        {
                            "liberacion": [
                                {
                                    "fecha": "20-11-2019",
                                    "inspector": "AZARIEL JULIAN RIOS",
                                    "litros": 2410,
                                    "grado": 46,
                                    "lote": "05069"
                                }
                            ],
                            "loteGranel": "SH-27",
                            "folio": "51000324BROX",
                            "litros": 2507,
                            "grado": 46.02,
                            "fecha": "12-02-2019",
                            "loteDos": null,
                            "observaciones": null,
                            "litrosExi": 0,
                            "gradoExi": 46.02,
                            "inspector": "DANIEL MERINO LOPEZ",
                            "tipoMov": "9",
                            "movimientoLote": "05075",
                            "descripcion": "SALIDA POR INGRESO A MADURACION EN BARRICAS"
                        },
                        {
                            "liberacion": [
                                {
                                    "fecha": "20-11-2019",
                                    "inspector": "AZARIEL JULIAN RIOS",
                                    "litros": 2410,
                                    "grado": 46,
                                    "lote": "05069"
                                }
                            ],
                            "loteGranel": "008.1/16",
                            "folio": "4000894VR",
                            "litros": 114,
                            "grado": 55.4,
                            "fecha": "07-06-2019",
                            "loteDos": null,
                            "observaciones": null,
                            "litrosExi": 114,
                            "gradoExi": 55.4,
                            "inspector": "ELIOENAI GAYTAN VENTURA",
                            "tipoMov": "7",
                            "movimientoLote": "008.1/16",
                            "descripcion": "SALIDA POR INGRESO A MADURACION EN VIDRIO"
                        }
                    ]
                },
                {
                    "traslados": [
                        {
                            "clienteSalida": "0051",
                            "instalacionSalida": "FABRICA 2 PEDRO CRUZ RUIZ",
                            "clienteDestino": "0051",
                            "instalacionDestino": "FABRICA 2 PEDRO CRUZ RUIZ",
                            "lote": "VID-192",
                            "litros": 17440,
                            "grado": 42,
                            "fecha": "17-04-2019",
                            "tr": "17440",
                            "inspector": "UZIEL CRUZ BORJAS",
                            "tipoTR": "tr"
                        }
                    ]
                },
                {
                    "instalacion": "2 PEDRO CRUZ RUIZ (MESTRO: PEDRO CRUZ RUIZ)",
                    "litrosExistentes": 0
                },
                {
                    "recepcionTR": [
                        {
                            "clienteSalida": "0051",
                            "instalacionSalida": "FABRICA 2 PEDRO CRUZ RUIZ",
                            "clienteDestino": "0051",
                            "instalacionDestino": "FABRICA 2 PEDRO CRUZ RUIZ",
                            "lote": "VID-192",
                            "litros": 17440,
                            "grado": 42,
                            "fecha": "17-04-2019",
                            "tr": "17440",
                            "inspector": "UZIEL CRUZ BORJAS",
                            "tipoTR": "tr"
                        }
                    ]
                }
            ],
            "ENVASADORA": [
                {
                    "ingreso": [
                        {
                            "loteEnvasadora": "VID-212",
                            "litros": 79595.8,
                            "grado": 42,
                            "loteFormo": "VID-212",
                            "inspector": "TRASLADO AUTOMATICO",
                            "fecha": "24-03-2021"
                        }
                    ]
                },
                {
                    "alta": [
                        {
                            "loteEnvasadora": "VID-212",
                            "litros": 79595.8,
                            "grado": 42,
                            "inspector": "TRASLADO AUTOMATICO",
                            "fecha": "24-03-2021"
                        }
                    ]
                },
                {
                    "movimientos": [
                        {
                            "loteGranel": "VID-212",
                            "folio": "",
                            "litros": 3,
                            "grado": 42.13,
                            "fecha": "30-03-2021",
                            "loteDos": "",
                            "litrosExi": 0,
                            "gradoExi": 0,
                            "inspector": "MARIO ISAIAS MIJANGOS HERNANDEZ",
                            "tipoMov": "11",
                            "movimientoLote": "",
                            "descripcion": "SALIDA POR MALA COMUNICACIÓN EN EL TRASLADO DE PRODUCTO Y MUESTREO DEL MISMO EN FABRICA SLR, SE ELIMINAN 3 LITROS PARA CORRESPONDER AL ANALISIS FISICO QUIMICO."
                        },
                        {
                            "liberacion": [
                                {
                                    "fecha": "20-11-2019",
                                    "inspector": "AZARIEL JULIAN RIOS",
                                    "litros": 2410,
                                    "grado": 46,
                                    "lote": "05069"
                                }
                            ],
                            "loteGranel": "TEP18",
                            "folio": "61000103VROX",
                            "litros": 40,
                            "grado": 45.87,
                            "fecha": "22-04-2020",
                            "loteDos": "",
                            "litrosExi": 40,
                            "gradoExi": 45.87,
                            "inspector": "VICTOR LUNA ROJAS",
                            "tipoMov": "7",
                            "movimientoLote": "TEP 18-VI",
                            "descripcion": "SALIDA POR INGRESO A MADURACION EN VIDRIO"
                        }
                    ]
                },
                {
                    "traslados": [
                        {
                            "clienteSalida": "0051",
                            "instalacionSalida": "FABRICA 2 PEDRO CRUZ RUIZ",
                            "clienteDestino": "0051",
                            "instalacionDestino": "FABRICA 2 PEDRO CRUZ RUIZ",
                            "lote": "VID-192",
                            "litros": 17440,
                            "grado": 42,
                            "fecha": "17-04-2019",
                            "tr": "17440",
                            "inspector": "UZIEL CRUZ BORJAS",
                            "tipoTR": "tr"
                        }
                    ]
                },
                {
                    "envasados": [
                        {
                            "clienteSolicita": "0051",
                            "solNombre": "DEL MAGUEY SINGLE VILLAGE MEZCAL S.A DE C.V.",
                            "clienteDueno": "0051",
                            "dueNombre": "DEL MAGUEY SINGLE VILLAGE MEZCAL S.A DE C.V.",
                            "marca": "VIDA DE SAN LUIS DEL RIO",
                            "lote": "VID-212",
                            "clase": "BLANCO O JOVEN",
                            "categoria": "MEZCAL ARTESANAL",
                            "presentacion": 750,
                            "unidad": "MILILITROS",
                            "botellas": 318,
                            "litros": 238.5,
                            "inspector": "MARIO ISAIAS MIJANGOS HERNANDEZ",
                            "fecha": "29-04-2021",
                            "grado": 42,
                            "rangosHologramas": null,
                            "tipomov": "12"
                        },
                        {
                            "clienteSolicita": "0051",
                            "solNombre": "DEL MAGUEY SINGLE VILLAGE MEZCAL S.A DE C.V.",
                            "clienteDueno": "0051",
                            "dueNombre": "DEL MAGUEY SINGLE VILLAGE MEZCAL S.A DE C.V.",
                            "marca": "VIDA DE SAN LUIS DEL RIO",
                            "lote": "VID-212",
                            "clase": "BLANCO O JOVEN",
                            "categoria": "MEZCAL ARTESANAL",
                            "presentacion": 750,
                            "unidad": "MILILITROS",
                            "botellas": 9360,
                            "litros": 7020,
                            "inspector": "HUGO BAUTISTA GARCIA",
                            "fecha": "06-05-2021",
                            "grado": 42,
                            "rangosHologramas": null,
                            "tipomov": "12"
                        },
                        {
                            "clienteSolicita": "0051",
                            "solNombre": "DEL MAGUEY SINGLE VILLAGE MEZCAL S.A DE C.V.",
                            "clienteDueno": null,
                            "dueNombre": null,
                            "marca": "PRODUCTO NO TERMINADO",
                            "lote": "VID-211",
                            "clase": "BLANCO O JOVEN",
                            "categoria": "MEZCAL ARTESANAL",
                            "presentacion": 30,
                            "unidad": "MILILITROS",
                            "botellas": 1700,
                            "litros": 51,
                            "inspector": "MARIO ISAIAS MIJANGOS HERNANDEZ",
                            "fecha": "20-04-2021",
                            "grado": 0,
                            "rangosHologramas": "<2709553 - 2709582>,<2709643 - 2709702>,<2709583 - 2709612>,<2709613 - 2709642>,<2709703 - 2709852>",
                            "tipomov": "12"
                        },
                        {
                            "clienteSolicita": "0051",
                            "solNombre": "DEL MAGUEY SINGLE VILLAGE MEZCAL S.A DE C.V.",
                            "clienteDueno": "0051",
                            "dueNombre": "DEL MAGUEY SINGLE VILLAGE MEZCAL S.A DE C.V.",
                            "marca": "VIDA DE SAN LUIS DEL RIO",
                            "lote": "VID-211",
                            "clase": "BLANCO O JOVEN",
                            "categoria": "MEZCAL ARTESANAL",
                            "presentacion": 750,
                            "unidad": "MILILITROS",
                            "botellas": 5976,
                            "litros": 4482,
                            "inspector": "MARIO ISAIAS MIJANGOS HERNANDEZ",
                            "fecha": "09-03-2021",
                            "grado": 42,
                            "rangosHologramas": null,
                            "tipomov": "12",
                            "salidas": [
                                {
                                    "tipo": "salida",
                                    "destino": "EXPORTACIÓN",
                                    "botellas": 5976,
                                    "cajas": "996",
                                    "botCajas": "6",
                                    "fecha": "13-04-2021",
                                    "inspector": "MARIO ISAIAS MIJANGOS HERNANDEZ"
                                }
                            ]
                        }
                    ]
                },
                {
                    "instalacion": "DEL MAGUEY SINGLE VILLAGE MEZCAL (ENCARGADO: ARTURO RAMIREZ ZENTENO) ",
                    "litros": 0
                },
                {
                    "recepcionTR": [
                        {
                            "clienteSalida": "0051",
                            "instalacionSalida": "FABRICA 2 PEDRO CRUZ RUIZ",
                            "clienteDestino": "0051",
                            "instalacionDestino": "FABRICA 2 PEDRO CRUZ RUIZ",
                            "lote": "VID-192",
                            "litros": 17440,
                            "grado": 42,
                            "fecha": "17-04-2019",
                            "tr": "17440",
                            "inspector": "UZIEL CRUZ BORJAS",
                            "tipoTR": "tr"
                        }
                    ]
                }
            ]
        }
    }

    const modalSeleccionarTipoMovimiento = () => {
        return (
            <Fragment>
                {
                    <Modal
                        open={openTipoMovimiento}
                        onClose={handleCloseTipoMovimiento}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={style} style={{ overflow: 'scroll' }}>
                            {/* para trazabilidad sustituir el de prueba por el props.trazabilidad */}
                            <VisualizarMovimientosComponent tipoBusqueda={props.tipoBusqueda} trazabilidad={objetoPruebas}></VisualizarMovimientosComponent>
                        </Box>

                    </Modal>
                }
            </Fragment>

        )
    }

    return (
        <Fragment><br />
            {
                props.tipoBusqueda == 1 ?
                    <div className="container mt-5">
                        <div className="row">
                            <div className="col">
                                <h2><strong>Trazabilidad</strong></h2>
                            </div>
                            <div className="col" style={{ textAlign: 'end' }}>
                                <button className='btn btn-success' onClick={() => handleOpenTipoMovimiento()}>VER MOVIMIENTOS</button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div id="caratula FI-25" className={`row mb-6 mt-3 ${estilos.seccion}`}>
                                    <label className={`${estilos.labelUI} mb-2`}>SECCION 1</label>
                                </div>
                                <table className="table table-bordered">
                                    <tbody>
                                        <tr>
                                            <th scope="row">ID</th>
                                            <td>{props.trazabilidad.id}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Método de Cocción</th>
                                            <td>{props.trazabilidad.metodoCoccion}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Fecha de Registro</th>
                                            <td>{props.trazabilidad.fechaRegistro}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Cliente</th>
                                            <td>{props.trazabilidad.cliente}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Fabrica</th>
                                            <td>{props.trazabilidad.fabrica}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Estado</th>
                                            <td>{props.trazabilidad.estado}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Maestro</th>
                                            <td>{props.trazabilidad.maestro}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Tapada</th>
                                            <td>{props.trazabilidad.tapada}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            {/* <div className="col-md-3">
                        <div id="caratula FI-25" className={`row mb-6 mt-3 ${estilos.seccion}`}>
                            <label className={`${estilos.labelUI} mb-2`}>SECCION 2</label>
                        </div>
                        <table className="table table-bordered">
                            <tbody>
                                <tr>
                                    <th scope="row">Fabrica</th>
                                    <td>{props.trazabilidad.fabrica}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Estado</th>
                                    <td>{props.trazabilidad.estado}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Maestro</th>
                                    <td>{props.trazabilidad.maestro}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Tapada</th>
                                    <td>{props.trazabilidad.tapada}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}
                            <div className="col-md-6">
                                <div id="caratula FI-25" className={`row mb-6 mt-3 ${estilos.seccion}`}>
                                    <label className={`${estilos.labelUI} mb-2`}>SECCION 3</label>
                                </div>
                                <table className="table table-bordered">
                                    <tbody>
                                        <tr>
                                            <th scope="row">Predio</th>
                                            <td>{props.trazabilidad.predio}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Predio Ensamble</th>
                                            <td>{props.trazabilidad.predioEnsamble}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Maguey</th>
                                            <td>{props.trazabilidad.maguey}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Maguey Ensamble</th>
                                            <td>{props.trazabilidad.magueyEnsamble}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Piñas</th>
                                            <td>{props.trazabilidad.pinas}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Agave Cocción</th>
                                            <td>{props.trazabilidad.agaveCoccion}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Periodo Cocción Inicial</th>
                                            <td>{props.trazabilidad.periodoCoccionI}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Periodo Cocción Final</th>
                                            <td>{props.trazabilidad.periodoCoccionF}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            {/* <div className="col-md-3">
                        <div id="caratula FI-25" className={`row mb-6 mt-3 ${estilos.seccion}`}>
                            <label className={`${estilos.labelUI} mb-2`}>SECCION 4</label>
                        </div>
                        <table className="table table-bordered">
                            <tbody>
                                <tr>
                                    <th scope="row">Piñas</th>
                                    <td>{props.trazabilidad.pinas}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Agave Cocción</th>
                                    <td>{props.trazabilidad.agaveCoccion}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Periodo Cocción Inicial</th>
                                    <td>{props.trazabilidad.periodoCoccionI}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Periodo Cocción Final</th>
                                    <td>{props.trazabilidad.periodoCoccionF}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <div id="caratula FI-25" className={`row mb-6 mt-3 ${estilos.seccion}`}>
                                    <label className={`${estilos.labelUI} mb-2`}>SECCION 5</label>
                                </div>
                                <table className="table table-bordered">
                                    <tbody>
                                        <tr>
                                            <th scope="row">Art</th>
                                            <td>{props.trazabilidad.art}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Periodo Molienda Inicial</th>
                                            <td>{props.trazabilidad.periodoMoliendaI}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Periodo Molienda Final</th>
                                            <td>{props.trazabilidad.periodoMoliendaF}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Periodo Formulación Inicial</th>
                                            <td>{props.trazabilidad.periodoFormulacionI}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Periodo Formulación Final</th>
                                            <td>{props.trazabilidad.periodoFormulacionF}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Periodo Destilación Inicial</th>
                                            <td>{props.trazabilidad.periodoDestilacionI}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Periodo Destilación Final</th>
                                            <td>{props.trazabilidad.periodoDestilacionF}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">No. Destilaciones</th>
                                            <td>{props.trazabilidad.noDestilaciones}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            {/* <div className="col-md-3">
                        <div id="caratula FI-25" className={`row mb-6 mt-3 ${estilos.seccion}`}>
                            <label className={`${estilos.labelUI} mb-2`}>SECCION 6</label>
                        </div>
                        <table className="table table-bordered">
                            <tbody>
                                <tr>
                                    <th scope="row">Periodo Formulación Final</th>
                                    <td>{props.trazabilidad.periodoFormulacionF}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Periodo Destilación Inicial</th>
                                    <td>{props.trazabilidad.periodoDestilacionI}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Periodo Destilación Final</th>
                                    <td>{props.trazabilidad.periodoDestilacionF}</td>
                                </tr>
                                <tr>
                                    <th scope="row">No. Destilaciones</th>
                                    <td>{props.trazabilidad.noDestilaciones}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}
                            <div className="col-md-6">
                                <div id="caratula FI-25" className={`row mb-6 mt-3 ${estilos.seccion}`}>
                                    <label className={`${estilos.labelUI} mb-2`}>SECCION 7</label>
                                </div>
                                <table className="table table-bordered">
                                    <tbody>
                                        <tr>
                                            <th scope="row">Litros Producidos</th>
                                            <td>{props.trazabilidad.ltsProducidos}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Grado</th>
                                            <td>{props.trazabilidad.grado}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Litros Existentes</th>
                                            <td>{props.trazabilidad.ltsExistentes}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Estatus</th>
                                            <td>{props.trazabilidad.estatus}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Inspector</th>
                                            <td>{props.trazabilidad.inspector}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Método Molienda</th>
                                            <td>{props.trazabilidad.metodoMolienda}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Método Fermentación</th>
                                            <td>{props.trazabilidad.metodoFermentacion}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Método Destilación</th>
                                            <td>{props.trazabilidad.metodoDestilacion}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            {/* <div className="col-md-3">
                        <div id="caratula FI-25" className={`row mb-6 mt-3 ${estilos.seccion}`}>
                            <label className={`${estilos.labelUI} mb-2`}>SECCION 8</label>
                        </div>
                        <table className="table table-bordered">
                            <tbody>
                                <tr>
                                    <th scope="row">Inspector</th>
                                    <td>{props.trazabilidad.inspector}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Método Molienda</th>
                                    <td>{props.trazabilidad.metodoMolienda}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Método Fermentación</th>
                                    <td>{props.trazabilidad.metodoFermentacion}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Método Destilación</th>
                                    <td>{props.trazabilidad.metodoDestilacion}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}
                        </div>
                    </div>
                    :
                    props.tipoBusqueda == 2 ?
                        <div className="container mt-5">
                            <div className="row">
                                <div className="col">
                                    <h2><strong>Trazabilidad</strong></h2>
                                </div>
                                <div className="col" style={{ textAlign: 'end' }}>
                                    <button className='btn btn-success' onClick={() => handleOpenTipoMovimiento()}>VER MOVIMIENTOS</button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div id="caratula FI-25" className={`row mb-6 mt-3 ${estilos.seccion}`}>
                                        <label className={`${estilos.labelUI} mb-2`}>Información General</label>
                                    </div>
                                    <table className="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <th scope="row">ID</th>
                                                <td>{props.trazabilidad.id}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Fecha de Registro</th>
                                                <td>{props.trazabilidad.fechaRegistro}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Cliente</th>
                                                <td>{props.trazabilidad.cliente}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Lote</th>
                                                <td>{props.trazabilidad.lote}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Maguey</th>
                                                <td>{props.trazabilidad.maguey}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Tanque</th>
                                                <td>{props.trazabilidad.tanque}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">FQ</th>
                                                <td>{props.trazabilidad.fq}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Clase</th>
                                                <td>{props.trazabilidad.clase}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Categoría</th>
                                                <td>{props.trazabilidad.categoria}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Abocante</th>
                                                <td>{props.trazabilidad.abocante}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Ingrediente</th>
                                                <td>{props.trazabilidad.ingrediente}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="col-md-6">
                                    <div id="caratula FI-25" className={`row mb-6 mt-3 ${estilos.seccion}`}>
                                        <label className={`${estilos.labelUI} mb-2`}>Datos de Producción</label>
                                    </div>
                                    <table className="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <th scope="row">Litros de Entrada</th>
                                                <td>{props.trazabilidad.ltsEntrada}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Grado de Entrada</th>
                                                <td>{props.trazabilidad.gradoEntrada}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Litros Existentes</th>
                                                <td>{props.trazabilidad.ltsExistentes}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Grado Existente</th>
                                                <td>{props.trazabilidad.gradoExistente}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Inspector</th>
                                                <td>{props.trazabilidad.inspector}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        :
                        props.tipoBusqueda == 3 ?
                            <div className="container mt-5">
                                <div className="row">
                                    <div className="col">
                                        <h2><strong>Trazabilidad</strong></h2>
                                    </div>
                                    <div className="col" style={{ textAlign: 'end' }}>
                                        <button className='btn btn-success' onClick={() => handleOpenTipoMovimiento()}>VER MOVIMIENTOS</button>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div id="caratula FI-25" className={`row mb-6 mt-3 ${estilos.seccion}`}>
                                            <label className={`${estilos.labelUI} mb-2`}>Información General</label>
                                        </div>
                                        <table className="table table-bordered">
                                            <tbody>
                                                <tr>
                                                    <th scope="row">ID</th>
                                                    <td>{props.trazabilidad.id}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Fecha de Registro</th>
                                                    <td>{props.trazabilidad.fechaRegistro}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Cliente</th>
                                                    <td>{props.trazabilidad.cliente}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Lote</th>
                                                    <td>{props.trazabilidad.lote}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Maguey</th>
                                                    <td>{props.trazabilidad.maguey}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Tanque</th>
                                                    <td>{props.trazabilidad.tanque}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">FQ</th>
                                                    <td>{props.trazabilidad.fq}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Clase</th>
                                                    <td>{props.trazabilidad.clase}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Categoría</th>
                                                    <td>{props.trazabilidad.categoria}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Abocante</th>
                                                    <td>{props.trazabilidad.abocante}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Ingrediente</th>
                                                    <td>{props.trazabilidad.ingrediente}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="col-md-6">
                                        <div id="caratula FI-25" className={`row mb-6 mt-3 ${estilos.seccion}`}>
                                            <label className={`${estilos.labelUI} mb-2`}>Datos de Producción</label>
                                        </div>
                                        <table className="table table-bordered">
                                            <tbody>
                                                <tr>
                                                    <th scope="row">Litros de Entrada</th>
                                                    <td>{props.trazabilidad.ltsEntrada}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Grado de Entrada</th>
                                                    <td>{props.trazabilidad.gradoEntrada}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Litros Existentes</th>
                                                    <td>{props.trazabilidad.ltsExistentes}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Grado Existente</th>
                                                    <td>{props.trazabilidad.gradoExistente}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Inspector</th>
                                                    <td>{props.trazabilidad.inspector}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            :
                            props.tipoBusqueda == 4 ?
                                <div className="container mt-5">
                                    <div className="row">
                                        <div className="col">
                                            <h2><strong>Trazabilidad</strong></h2>
                                        </div>
                                        <div className="col" style={{ textAlign: 'end' }}>
                                            <button className='btn btn-success' onClick={() => handleOpenTipoMovimiento()}>VER MOVIMIENTOS</button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div id="caratula FI-25" className={`row mb-6 mt-3 ${estilos.seccion}`}>
                                                <label className={`${estilos.labelUI} mb-2`}>Información General</label>
                                            </div>
                                            <table className="table table-bordered">
                                                <tbody>
                                                    <tr>
                                                        <th scope="row">ID</th>
                                                        <td>{props.trazabilidad.id}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Cliente</th>
                                                        <td>{props.trazabilidad.cliente}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Fecha de Registro</th>
                                                        <td>{props.trazabilidad.fechaRegistro}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Marca</th>
                                                        <td>{props.trazabilidad.marca}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Lote</th>
                                                        <td>{props.trazabilidad.lote}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Maguey</th>
                                                        <td>{props.trazabilidad.maguey}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">FQ</th>
                                                        <td>{props.trazabilidad.fq}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Clase</th>
                                                        <td>{props.trazabilidad.clase}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Categoría</th>
                                                        <td>{props.trazabilidad.categoria}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Abocante</th>
                                                        <td>{props.trazabilidad.abocante}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Ingrediente</th>
                                                        <td>{props.trazabilidad.ingrediente}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="col-md-6">
                                            <div id="caratula FI-25" className={`row mb-6 mt-3 ${estilos.seccion}`}>
                                                <label className={`${estilos.labelUI} mb-2`}>Datos de Producción</label>
                                            </div>
                                            <table className="table table-bordered">
                                                <tbody>
                                                    <tr>
                                                        <th scope="row">Unidad</th>
                                                        <td>{props.trazabilidad.unidad}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Contenido</th>
                                                        <td>{props.trazabilidad.contenido}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Litros</th>
                                                        <td>{props.trazabilidad.litros}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Botellas</th>
                                                        <td>{props.trazabilidad.botellas}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Botellas Existentes</th>
                                                        <td>{props.trazabilidad.botellasEx}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Grado</th>
                                                        <td>{props.trazabilidad.grado}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Inspector</th>
                                                        <td>{props.trazabilidad.inspector}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Lote Granel</th>
                                                        <td>{props.trazabilidad.loteGranel}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Rangos</th>
                                                        <td>{props.trazabilidad.rangos}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                :
                                <Fragment />
            }
            {modalSeleccionarTipoMovimiento()}
        </Fragment>
    );
};


export default withRouter(VisualizarTrazabilidad)
